import React from "react";
import { Avatar } from "primereact/avatar";

export const AppProfile = () => {
    return (
        <div className="layout-profile">
            <Avatar icon="pi pi-user" className="mr-2 p-mb-2" size="xlarge" shape="circle" style={{ backgroundColor: "#2196F3", color: "#ffffff" }} />
            <div className="user-text">
                <p>
                    Hello, <span>{localStorage.getItem("userName") ? localStorage.getItem("userName") : "User"}</span>
                </p>
                <p>{localStorage.getItem("userEmail") ? localStorage.getItem("userEmail") : "User Email"}</p>
            </div>
        </div>
    );
};
